import React, { useState, useEffect, useContext } from 'react'
import { Form, Toast } from 'antd-mobile';
import { UserContext } from 'utils/getContext'
import { onSubmitForm } from "api/api";
import { recruitPage1, recruitPage2, recruitPage3 } from 'data/recruitForm';
import { getFJJobWantedObj, getUserObj, getSkillObj, getPostObj } from 'utils/getData'
import { GetFormType } from "./GetFormType";
import { FromSteps } from "./FromSteps";

/** 我要招人 */
export function Recruit() {
  const { userInfo } = useContext(UserContext)
  const [form] = Form.useForm();
  const [postData, setPostData] = useState({})
  const [content, setContent] = useState({});
  const [stepNum, setStepNum] = useState(1)
  const [skillContent, setSkillContent] = useState([])
  const [areaContent, setAreaContent] = useState([])
  const [postContent, setPostContent] = useState([])
  const title = ['基本信息', '招聘要求', '岗位待遇', '提交申请']
  const pageData = [recruitPage1, recruitPage2, recruitPage3]

  /** 初始化数据 */
  useEffect(() => {
    getFJJobWantedObj('', areaContent, setAreaContent)
    getSkillObj('', '', skillContent, setSkillContent)
    getPostObj('', '', postContent, setPostContent)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** 更新提交表单接口参数数据 */
  function setFormInfo(name, value) {
    const newPostData = { ...postData }
    newPostData[name] = value
    // form.setFieldsValue();
    setPostData(newPostData)
  }
  /** 提交表单 */
  async function handleSubmitFormClick(setLoading) {
    if (stepNum < title.length - 1) {
      setStepNum(stepNum + 1)
    }
    if (stepNum === title.length - 1) {
      setLoading(true)
      try {
        const params = {
          serviceId: 120,
          params: {
            T_PSM_RecruitInfo: {
              ...postData,
              FCORPNAME: userInfo.name ? userInfo.name : undefined,
              FUNIFIEDCODE: userInfo.idNum ? userInfo.idNum : undefined,
              FTYPE: 45 // 45 为我要招人表单类型
            },
          },
        };
        if (stepNum === title.length - 1) {
          const res = await onSubmitForm(params);
          if (res.code === 200) {
            setStepNum(stepNum + 1)
          } else {
            Toast.show({
              icon: 'fail',
              content: '提交失败，请检查内容并重试',
            })
          }
        }
      } catch (e) {
        Toast.show({
          icon: 'fail',
          content: '提交失败，请检查内容并重试',
        })
      } finally {
        setLoading(false)
      }
    }
  }

  /** 初始化表单渲染模板 */
  const getType = (arr, index) =>
    <GetFormType
      key={index}
      item={arr}
      setFormInfo={setFormInfo}
      content={content}
      setContent={setContent}
      getUserObj={getUserObj}
      areaContent={areaContent}
      setAreaContent={setAreaContent}
      skillContent={skillContent}
      setSkillContent={setSkillContent}
      postContent={postContent}
      setPostContent={setPostContent}
      getAreaObj={getFJJobWantedObj}
      getSkillObj={getSkillObj}
      getPostObj={getPostObj}
      postInfo={postData}
    />

  // 根据步骤获取当前页面表单信息
  return (
    <FromSteps
      stepNum={stepNum} title={title}
      getType={getType} setStepNum={setStepNum}
      form={form} pageData={pageData}
      handleSubmitFormClick={handleSubmitFormClick}
    />
  )
}